module.exports = __webpack_public_path__ + "static/media/YearView.9cc517bf.svg";